<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <router-link to="/new-game" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></router-link>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Create room</h1>
                    </div>

                    <div class="col-2 text--right">
                        <router-link to="/help" class="btn btn--icon btn--white">?</router-link>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="intro-content pt--40">
                <div class="profile profile--vertical profile--lg mb--20">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img"><img v-bind:src="user.avatar" alt="" /></span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">Select game type</div>
                    </div>
                </div>
            </div>

            <form>
                <div class="row mb--lg">
                    <div class="col-4">
                        <div class="chooser__one">
                            <input type="radio" name="game-type-details" id="color-standard" v-model="data.gameType" value="simple_group_game" />
                            <label for="color-standard" class="chooser chooser--column chooser--standard mb--0 ">
                                    <span class="chooser__one-direction">
                                        <span class="icon icon--standard"></span>
                                        <span class="text">Standard</span>
                                    </span>
                            </label>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="chooser__one">
                            <input type="radio" name="game-type-details" v-model="data.gameType" id="color-knockout" value="knockout" />
                            <label for="color-knockout" class="chooser chooser--column chooser--knockout mb--0">
                                <span class="chooser__one-direction">
                                    <span class="icon icon--knockout"></span>
                                    <span class="text">Knockout</span>
                                </span>
                            </label>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="chooser__one">
                            <input type="radio" name="game-type-details"  v-model="data.gameType" id="color-custom" value="custom_group_game" />
                            <label for="color-custom" class="chooser chooser--column chooser--custom mb--0">
                                    <span class="chooser__one-direction">
                                        <span class="icon icon--custom"></span>
                                        <span class="text">Custom</span>
                                    </span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Game type - Room details-->
                <div class="mb--lg">
                    <div class="row mb--md opacity--sm">
                        <div class="col-12 text--center">
                            <span>Room details</span>
                        </div>
                    </div>

                    <!-- Game type - Room details - Standard -->
                    <input type="text" class="form-control mb--md" v-model="data.name" placeholder="Room name" />

                    <select class="form-control mb--md" v-model="data.level">
                        <option value="">Room level</option>
                        <option value="" v-for="level in filteredLevels" :value="level.id">{{ level.name }}</option>
                    </select>

                    <select class="form-control mb--md" v-model="data.category">
                        <option value="">All categories</option>
                        <option v-for="category in filteredCategories" :value="category.id"> {{ category.name }}</option>
                    </select>

                    <!-- Game type - Room details - Standard -->
                    <input type="text" class="form-control mb--md" v-model="data.password" placeholder="Room password (not recommended)" />


                    <!-- Game type - - Room details - Knockout-->
                    <select class="form-control mb--md" v-model="data.numberOfPlayers" v-show="data.gameType == 'knockout' || data.gameType == 'custom_group_game'">
                        <option value="0" v-html="numberOfPlayersText"></option>
                        <option value="2">2</option>
                        <option value="4">4</option>
                        <option value="8">8</option>
                        <option value="16">16</option>
                        <option value="32">32</option>
                    </select>
                    <!-- END Game type - - Room details - Knockout-->
                </div>
                <!-- Game type - Room details-->


                <!-- Game type - Add rules - Custom -->
                <div class="mb--md" v-show="data.gameType == 'custom_group_game'">
                    <div class="row mb--md opacity--sm">
                        <div class="col-12 text--center">
                            <span>Add rules</span>
                        </div>
                    </div>

                    <div class="row mb--md">
                        <div class="col-6">
                            <div class="chooser__one">
                                <input type="radio" v-model="data.rules" id="color-time-limit" value="time-limit" />
                                <label for="color-time-limit" class="chooser chooser--row chooser--time-limit mb--0">
                                        <span class="chooser__one-direction">
                                            <span class="icon icon--time-limit"></span>
                                            <span class="text">Time limit</span>
                                        </span>
                                </label>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="chooser__one">
                                <input type="radio" v-model="data.rules" id="color-game-limit" value="game-limit" />
                                <label for="color-game-limit" class="chooser chooser--row chooser--game-limit mb--0">
                                        <span class="chooser__one-direction">
                                            <span class="icon icon--game-limit"></span>
                                            <span class="text">Game limit</span>
                                        </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <select v-show="data.rules == 'time-limit'" class="form-control mb--md" v-model="data.timeLimit">
                        <option value="0">Choose an option</option>
                        <option value="10">10 minutes</option>
                        <option value="20">20 minutes</option>
                        <option value="30">30 minutes</option>
                        <option value="40">40 minutes</option>
                        <option value="50">50 minutes</option>
                        <option value="60">60 minutes</option>
                        <option value="70">70 minutes</option>
                        <option value="80">80 minutes</option>
                        <option value="90">90 minutes</option>
                    </select>

                    <select v-show="data.rules == 'game-limit'" class="form-control mb--md" v-model="data.gameLimit">
                        <option value="0">Choose an option</option>
                        <option :value="index" v-for="index in 20">{{ index }}</option>
                    </select>
                </div>
                <!-- END Game type - Add rules - Custom -->

                <button type="button" @click="create" class="btn btn--block btn--primary">Create room</button>
            </form>

            <modal show="false" type="error" ref="validationModal">
                <template v-slot:message>
                    <div v-if="errors.any()">
                        <div v-for="error in errors.all()">{{ error }}</div>
                    </div>
                </template>

                <template v-slot:title>
                    Error
                </template>

                <template v-slot:buttons><span></span></template>
            </modal>
            <modal show="false" type="error" ref="permissionModal">
                <template v-slot:message>
                    you don't have permission to access this feature!
                </template>

                <template v-slot:title>
                    Error
                </template>

                <template v-slot:buttons><span></span></template>
            </modal>

        </section>
    </div>
</template>

<script>
import Errors from "../../util/Errors";
import api from "../../api/createChannel";
import {mapGetters} from "vuex";

export default {
    name: "CreateChannel",

    data: function () {
        return {
            data: {
                name: '',
                password: '',
                level: '',
                category: '',
                numberOfPlayers: 0,
                rules: 'time-limit',
                timeLimit: 0,
                gameLimit: 0,
                isPublic: 1,
                gameType: 'simple_group_game'
            },
            categories: [],
            levels: [
                {id: 1, name: 'Level 1'},
                {id: 2, name: 'Level 2'},
                {id: 3, name: 'Level 3'},
                {id: 4, name: 'Level 4'}
            ],
            errors: new Errors(),
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user',
        ]),

        filteredCategories() {
            if (this.data.level) {
                return this.categories.filter(category => category.levels.includes(parseInt(this.data.level)))
            }

            return this.categories
        },

        filteredLevels() {
            if (this.data.category) {
                let category = this.categories.find(category => category.id === parseInt(this.data.category))

                return this.levels.filter(level => category.levels.includes(level.id))
            }

            return this.levels
        },

        numberOfPlayersText() {
            if (this.data.gameType == 'custom_group_game') {
                return 'No user limit'
            }

            return 'Number of players'
        }
    },

    methods: {
        async create() {
            try {
                let response = await api.create(this.data)

                this.$router.push(response.data.data.url)
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors.record(error.response.data.errors)
                    this.$refs.validationModal.open()
                }

                if (error.response.status === 403) {
                    this.$refs.permissionModal.open()
                }
            }
        },

        async loadCategories() {
            let response = await api.getCategories()

            this.categories = response.data.data
        }
    },

    created() {
        this.loadCategories()
    }
}
</script>